import { render, staticRenderFns } from "./BtnWhatsApp.vue?vue&type=template&id=2a0ff948&scoped=true"
import script from "./BtnWhatsApp.vue?vue&type=script&lang=js"
export * from "./BtnWhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0ff948",
  null
  
)

export default component.exports